export default () => ({
  container: {
    border: "2px dashed #dadada",
    background: "#FFFFFF",
    display: "flex",
    padding: "28px 20px",
    // minWidth: 320,
    maxWidth: "100%",
    cursor: "pointer",
    "&:hover": {
      border: "2px dashed #26bbed",
    }
  },
  thumb: {
    width: 80,
    height: 80,
    backgroundImage: "linear-gradient(180deg, #F9F9F9 0%, #EDEDED 100%)",
    borderRadius: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    cursor: "pointer"
  },
  dark: {
    color: "#555555",
    marginRight: 2
  },
  addressContainer: {
    padding: "0 20px",
    width: "90%",
  },
  nameText: {
    fontFamily: "'Open Sans', sans-serif;",
    fontWeight: "bold"
  },
  addressText: {
    fontSize: 16,
    fontFamily: "'Open Sans', sans-serif;",
    overflow: "hidden",

  },
  marginAddressVenue: {
    marginTop: 10,
    textOverflow: "ellipsis",
    overflow: "hidden",
    // whiteSpace: "nowrap"

  },

  marginAddressZoom: {
    marginTop: 15
  },

  popoverBody: {
    width: 367,
    padding: "20px 27px 27px 20px"
  },
  popoverText: {
    fontSize: 16,
    color: "#333333",
  },
  popoverWidth: {
    width: "-webkit-fill-available"
  },
  button: {
    width: "-webkit-fill-available",
    marginTop: 20
  },
  zoomText: {
    height: 80,
    width: 80,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"

    // color: "#4A8CFF",
    // fontWeight: 600
  },
  zoomIcon: {
    height: 20,
    width: 20,
    borderRadius: 10,
    background: "#4A8CFF",
    color: "white",
    display: "flex",
    marginLeft: 10
  },
  flexBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: 'center',
    height: 24
  },
  iconPencil: {
    color: "#DADADA",
    // display: "none",
    // "&:hover": {
    //   display: "flex"
    // }
  },
  venueAddress: {
    color: "rgba(51,51,51,0.75)",
    fontSize: 12,
    marginBottom: 4
  },
  validation: {
    color: "red"
  },
  root: {
    flexDirection: "row"
  },
  openBorder:{
    border: "2px dashed #999999 !important",
  }
})